import ReadOnlyService from '../base/ReadOnlyService';

class ProjectSize extends ReadOnlyService {
  constructor() {
    super('project-sizes');
  }
}

export default new ProjectSize();
